import { createActions } from 'reduxsauce'

/* ------------- Types and Action Creators ------------- */
const { Types, Creators } = createActions({
  // Create Video
  videoCreateRequest: ['scriptId', 'audioUrl', 'segments', 'options', 'callback'],
  videoCreateSuccess: ['data'],
  videoCreateFailure: ['error'],

  // Get Video
  videoGetRequest: ['id', 'callback'],
  videoGetSuccess: ['data'],
  videoGetFailure: ['error'],

  // Get Video Status
  videoStatusRequest: ['id', 'callback'],
  videoStatusSuccess: ['status'],
  videoStatusFailure: ['error'],

  // List Videos for Script
  videoListRequest: ['scriptId', 'callback'],
  videoListSuccess: ['list'],
  videoListFailure: ['error'],

  // Poll Video Until Complete
  videoPollRequest: ['id', 'interval', 'callback'],
  videoPollSuccess: ['data'],
  videoPollFailure: ['error'],
  videoPollProgress: ['status'],

  // Generate Video (create + poll)
  videoGenerateRequest: ['scriptId', 'audioUrl', 'segments', 'options', 'callback'],
  videoGenerateSuccess: ['data'],
  videoGenerateFailure: ['error'],
  videoGenerateProgress: ['status'],

  // Set current video
  setCurrentVideo: ['video'],
  clearCurrentVideo: [],

  // Reset
  videoReset: [],
})

export const VideoTypes = Types
export default Creators

/* ------------- Initial State ------------- */
const INITIAL_STATE = {
  // Create
  createFetching: false,
  createError: null,
  createdData: null,

  // Get
  data: null,
  fetching: false,
  error: null,

  // List
  list: [],
  listFetching: false,
  listError: null,

  // Poll
  polling: false,
  pollStatus: null,
  pollError: null,

  // Generate (create + poll)
  generating: false,
  generateProgress: null,
  generateError: null,

  // Current video
  currentVideo: null,
}

/* ------------- Reducer ------------- */
export const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // Create
    case Types.VIDEO_CREATE_REQUEST:
      return { ...state, createFetching: true, createError: null }
    case Types.VIDEO_CREATE_SUCCESS:
      return { ...state, createFetching: false, createError: null, createdData: action.data }
    case Types.VIDEO_CREATE_FAILURE:
      return { ...state, createFetching: false, createError: action.error }

    // Get
    case Types.VIDEO_GET_REQUEST:
      return { ...state, fetching: true, error: null }
    case Types.VIDEO_GET_SUCCESS:
      return { ...state, data: action.data, fetching: false, error: null }
    case Types.VIDEO_GET_FAILURE:
      return { ...state, fetching: false, error: action.error }

    // Status
    case Types.VIDEO_STATUS_REQUEST:
      return { ...state, fetching: true, error: null }
    case Types.VIDEO_STATUS_SUCCESS:
      return { ...state, fetching: false, pollStatus: action.status }
    case Types.VIDEO_STATUS_FAILURE:
      return { ...state, fetching: false, error: action.error }

    // List
    case Types.VIDEO_LIST_REQUEST:
      return { ...state, listFetching: true, listError: null }
    case Types.VIDEO_LIST_SUCCESS:
      return { ...state, list: action.list, listFetching: false, listError: null }
    case Types.VIDEO_LIST_FAILURE:
      return { ...state, listFetching: false, listError: action.error }

    // Poll
    case Types.VIDEO_POLL_REQUEST:
      return { ...state, polling: true, pollError: null }
    case Types.VIDEO_POLL_SUCCESS:
      return { ...state, polling: false, data: action.data, pollError: null }
    case Types.VIDEO_POLL_FAILURE:
      return { ...state, polling: false, pollError: action.error }
    case Types.VIDEO_POLL_PROGRESS:
      return { ...state, pollStatus: action.status }

    // Generate
    case Types.VIDEO_GENERATE_REQUEST:
      return { ...state, generating: true, generateError: null, generateProgress: null }
    case Types.VIDEO_GENERATE_SUCCESS:
      return { ...state, generating: false, data: action.data, generateError: null }
    case Types.VIDEO_GENERATE_FAILURE:
      return { ...state, generating: false, generateError: action.error }
    case Types.VIDEO_GENERATE_PROGRESS:
      return { ...state, generateProgress: action.status }

    // Current Video
    case Types.SET_CURRENT_VIDEO:
      return { ...state, currentVideo: action.video }
    case Types.CLEAR_CURRENT_VIDEO:
      return { ...state, currentVideo: null }

    // Reset
    case Types.VIDEO_RESET:
      return { ...INITIAL_STATE }

    default:
      return state
  }
}
